module.exports = __webpack_public_path__ + "images/marketing/sales-funnel-bluetext.svg";